import React from 'react';
import SectionHeader from './SectionHeader';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const projects = [
  { id: 1, title: "Neural Trader Pro", category: "FinTech AI", description: "Automated trading agent utilizing sentiment analysis on real-time news feeds to execute crypto trades.", tags: ["Python", "Transformers", "React"] },
  { id: 2, title: "Visionary Lens", category: "Computer Vision", description: "Real-time object detection and safety monitoring system for industrial manufacturing floors.", tags: ["YOLOv8", "OpenCV", "Edge Computing"] },
  { id: 3, title: "DocuMind LLM", category: "Knowledge Management", description: "Enterprise RAG (Retrieval-Augmented Generation) system for querying complex legal documents instantly.", tags: ["LangChain", "Pinecone", "Next.js"] }
];

const Projects = () => {
  return (
    <section id="projects" className="py-24 bg-obsidian relative">
      <div className="container mx-auto px-6 relative z-10">
        <SectionHeader title="Featured Builds" subtitle="Selected AI systems and agents engineered from idea to deployment." />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div 
              key={project.id} 
              initial={{ opacity: 0, y: 20 }} 
              whileInView={{ opacity: 1, y: 0 }} 
              transition={{ delay: index * 0.1 }} 
              viewport={{ once: true }} 
              className="group relative bg-carbon border border-white/5 hover:border-neon-cyan/50 transition-all duration-300 p-8 overflow-hidden"
            >
              <div className="absolute top-0 right-0 p-2 opacity-20 group-hover:opacity-100 transition-opacity">
                <SafeIcon icon={FiIcons.FiCpu} className="text-4xl text-neon-cyan" />
              </div>
              <div className="absolute bottom-0 left-0 w-full h-[2px] bg-neon-cyan scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              <div className="flex flex-col h-full">
                <span className="text-neon-cyan font-mono text-xs uppercase tracking-widest mb-2">{project.category}</span>
                <h3 className="text-2xl font-orbitron font-bold text-white mb-4 group-hover:text-neon-cyan transition-colors">{project.title}</h3>
                <p className="text-gray-400 text-sm mb-6 flex-grow leading-relaxed">{project.description}</p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {project.tags.map(tag => (
                    <span key={tag} className="px-2 py-1 bg-white/5 border border-white/10 text-[10px] font-mono text-gray-300 uppercase">{tag}</span>
                  ))}
                </div>
                <a href="#" className="inline-flex items-center gap-2 text-white font-bold text-sm uppercase tracking-wider group-hover:gap-4 transition-all">
                  View Case Study <SafeIcon icon={FiIcons.FiArrowRight} />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;